export const isSameDayDelivery = deliveryID => deliveryID.slice(0, 2) === 'SD';

export default {};
